const state = {
  activePhaseIndexes: [],
  createPDF: false
}

const getters = {
  getActivePhaseIndexes: state => {
    return state.activePhaseIndexes
  },
  getCreatePDF: state => {
    return state.createPDF
  }
}

const mutations = {
  setActivePhaseIndexes: (state, payload) => {
    state.activePhaseIndexes = payload.map(index => index - 1)
  },
  setCreatePDF: (state, payload) => {
    state.createPDF = payload
  }
}

const actions = {
  setActivePhaseIndexes: ({ commit }, activePhases) => {
    commit('setActivePhaseIndexes', activePhases)
  },
  setCreatePDF: ({ commit }, boolean) => {
    commit('setCreatePDF', boolean)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
